import Chip from "@mui/material/Chip";

const APP_VERSION = "1.194.0";

const AppVersion = () => {
  return <Chip style={{marginLeft: "60px", marginBottom: "10px", width: 120}} label={APP_VERSION} />;
};

export default AppVersion;
